import { render, staticRenderFns } from "./CropUsageCard.vue?vue&type=template&id=2dcf7b90&scoped=true&lang=html&"
import script from "./CropUsageCard.vue?vue&type=script&lang=js&"
export * from "./CropUsageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcf7b90",
  null
  
)

export default component.exports